module.exports = __webpack_public_path__ + "img/revo_phone_graph.522dfcf6.jpg";